export const tns = 'listings'
